import { html } from "lit-html";
import { DynamicSettings, ShowFarePrices } from "./DynamicSettings";
import { useSaveDynamicSettings } from "./useSaveDynamicSettings";

export interface Props {
	newSettings: DynamicSettings;
	setNewSettings: (settings: DynamicSettings) => void;
}

export const useFareCacheSection = (props: Props) => {
	const saver = useSaveDynamicSettings({ newSettings: props.newSettings });

	const handleLookaheadInput = (event: InputEvent) => {
		const value = Number((event.target as HTMLInputElement).value);
		props.setNewSettings({
			...props.newSettings,
			TimetableMaxMonthsFallback: isNaN(value) ? 0 : value,
		});
	};

	const checkboxTemplate = (data: { label: string; key: keyof ShowFarePrices }) => html`
		<admin-checkbox
			.checked=${props.newSettings.ShowFarePricesCultures[data.key]}
			.label=${data.label}
			.justify=${"start"}
			.onClick=${() =>
				props.setNewSettings({
					...props.newSettings,
					ShowFarePricesCultures: {
						...props.newSettings.ShowFarePricesCultures,
						[data.key]: !props.newSettings.ShowFarePricesCultures[data.key],
					},
				})}
		></admin-checkbox>
	`;

	const availabilityLookaheadSectionTemplate = () => html`
		<div class="my-6">
			<div class="w-80">
				<label class="mb-1 block text-sm"
					>Number of months to show availability in if FareCache is not available:</label
				>
				<input
					class="flex h-10 w-full appearance-none items-center rounded-lg border border-solid border-black px-4"
					type="number"
					value=${props.newSettings.TimetableMaxMonthsFallback.toString() || ""}
					@input=${handleLookaheadInput}
				/>
			</div>
		</div>
	`;

	const htmlTemplate = () => html`
		<section class="mt-5 max-w-[640px]">
			<div class="flex flex-col gap-2">
				${checkboxTemplate({ label: "Show Fare Prices for Chile", key: "Cl" })}
				${checkboxTemplate({ label: "Show Fare Prices for Argentina", key: "Ar" })}
				${checkboxTemplate({ label: "Show Fare Prices for Brazil", key: "Br" })}
				${checkboxTemplate({ label: "Show Fare Prices for Colombia", key: "Co" })}
				${checkboxTemplate({ label: "Show Fare Prices for Ecuador", key: "Ec" })}
				${checkboxTemplate({ label: "Show Fare Prices for Paraguay", key: "Py" })}
				${checkboxTemplate({ label: "Show Fare Prices for Peru", key: "Pe" })}
				${checkboxTemplate({ label: "Show Fare Prices for Uruguay", key: "Uy" })}
				${checkboxTemplate({ label: "Show Fare Prices for the USA", key: "Us" })}
				${checkboxTemplate({ label: "Show Fare Prices for the Dominican R.", key: "Do" })}
				${checkboxTemplate({ label: "Show Fare Prices for Others (EN)", key: "Gb" })}
				${availabilityLookaheadSectionTemplate()}
			</div>
			${saver.htmlTemplate()}
		</section>
	`;

	return { htmlTemplate };
};
